import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class TimeRoundingUtilsService {
  public static roundTimeForBilling(time: string): string | number {
    if (time.includes(':')) {
      // time has been input in hh:mm format
      const split = time.split(':');
      const hours = Number.parseFloat(split[0]);
      const minutes = Number.parseFloat(split[1]);

      if (hours == 0 && minutes == 0) {
        return '0:06';
      }

      let roundedMinutes = Math.ceil(minutes / 6) * 6;
      let roundedHours = hours;

      if (roundedMinutes == 60) {
        roundedMinutes = 0;
        roundedHours++;
      }

      return roundedHours.toString().padStart(2, '0') + ':' + roundedMinutes.toString().padStart(2, '0');
    } else {
      // time has been input in decimal format
      const decimalTime = Number.parseFloat(time);

      if (decimalTime == 0) {
        return 0.1;
      }

      const roundedTime = (Math.ceil((decimalTime * 60) / 6.0) * 6.0) / 60;

      return roundedTime.toFixed(2).toString();
    }
  }

  public static isTimeRounded(time: string, timeSaved?: string) {
    const t1 = time.includes('.') ? Number.parseFloat(time) : moment.duration(time).asHours();
    let t2 = 0;
    if (timeSaved) {
      t2 = timeSaved.includes('.') ? Number.parseFloat(timeSaved) : moment.duration(timeSaved).asHours();
    }
    const totalTime = t1 + t2;

    const roundedTime = this.roundTimeForBilling(totalTime.toString());

    return totalTime.toFixed(2) != roundedTime;
  }
}
